import customAxiosInterceptor from "../customAxiosInterceptor";

//https://infocomp.ba/api/post/latest?post_type="Solarni sistemi"
export const getSolarSystemInfoThunk = async (thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.get("post/latest", {
      params: { post_type: "Solarni sistemi" },
    });
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
};
